<template>
  <StackPageLayout @close="handleClose">
    <template #header>
      <PageTitle>Z Report Details</PageTitle>
    </template>

    <div
      v-if="isError"
      class="text-center text-sm font-semibold text-error"
    >
      Something went wrong fetching Z report
    </div>

    <div v-else-if="isLoading" class="relative h-full">
      <BaseInnerLoading class="bg-background/20" />
    </div>

    <section v-else-if="report" class="mb-6">
      <div class="flex flex-col items-center">
        <!-- Show originally printed receipt if available -->
        <pre
          v-if="report.receipt"
          class="w-max whitespace-pre rounded-lg bg-background p-4 font-mono text-sm ring-1 ring-background-fg/10"
          >{{ stripTags(report.receipt) }}</pre
        >

        <!-- otherwise fall back to the generatedReceipt and show disclaimer -->
        <div v-else class="flex flex-col items-center">
          <pre
            class="w-max whitespace-pre rounded-lg bg-background p-4 font-mono text-sm ring-1 ring-background-fg/10"
            >{{ generatedReceipt }}</pre
          >
          <p class="mt-2 text-xs text-background-fg/60">
            *** This is a system-generated reconstruction of
            your receipt. For official records please refer
            to the original printed receipt. ***
          </p>
        </div>
      </div>
    </section>
  </StackPageLayout>
</template>

<script setup lang="ts">
import { formatPartialZReport } from "@/services/reconciliation/formatPartialZReport"
import { useZReport } from "@/services/reconciliation/retrieveZReport"
import { computedAsync } from "@vueuse/core"
import type { RouteLocationRaw } from "vue-router"

const props = defineProps<{
  zReportId: string
  previousPage?: RouteLocationRaw
}>()

const router = useRouter()
const {
  data: report,
  isError,
  isLoading,
} = useZReport(props.zReportId)

const stripTags = (html: string) =>
  html.replace(/<[^>]*>/g, "")

const generatedReceipt = computedAsync(
  async () =>
    report.value && !report.value.receipt
      ? await formatPartialZReport(report.value)
      : "",
  null
)

const handleClose = () => {
  router.push(
    props.previousPage ?? {
      name: "settingsZReportHistory",
    }
  )
}
</script>
